import { ChevronDown, ChevronUp } from 'lucide-react';
import { type ReactElement, type ReactNode, useState } from 'react';

interface SurfaceAdvancedDetailsProps {
  /** 펼침 여부. 없으면 닫힌 채 시작해 스스로 펼치고 접는다. */
  readonly open?: boolean;
  readonly onToggle?: (open: boolean) => void;
  readonly children: ReactNode;
}

/**
 * 표면 인스펙터의 사진 % 칸·축척 줄을 접어 두는 칸(기본 닫힘). 표면은 '상품 추출하기'로 만들고, 이 칸은 미세 조정용이다.
 * 표면 패널이 펼침 상태를 쥐면 인스펙터가 다시 만들어져도 펼친 채 남는다. 펼침 표시는 인쇄 영역 줄과 같은 위·아래 화살표다.
 */
export const SurfaceAdvancedDetails = ({
  open,
  onToggle,
  children,
}: SurfaceAdvancedDetailsProps): ReactElement => {
  const [localOpen, setLocalOpen] = useState(false);
  const isOpen = open ?? localOpen;
  const Chevron = isOpen ? ChevronUp : ChevronDown;
  return (
    <details
      className="rounded border p-2"
      open={open}
      onToggle={(event) => {
        const next = event.currentTarget.open;
        setLocalOpen(next);
        onToggle?.(next);
      }}
    >
      <summary className="flex cursor-pointer list-none items-center justify-between gap-2 text-sm font-medium [&::-webkit-details-marker]:hidden">
        고급: 표면 수치 조정
        <Chevron aria-hidden="true" className="size-4 shrink-0" />
      </summary>
      <div className="mt-2 space-y-3">{children}</div>
    </details>
  );
};
